import { ClipboardList, Clock3, LockKeyhole, RefreshCw, ShieldCheck, X } from 'lucide-react'
import { useCallback, useEffect, useState, type FormEvent } from 'react'
import { supabase } from '../lib/supabase'

type GuestResponse={id?:string;error?:string;status?:string;message?:string;table_number?:number;items?:Array<{product_name:string;quantity:number;unit_price:number;total:number}>;total?:number;paid?:number;remaining?:number}
const money=new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'})
const sessionKey='goncalo_table_view_permission_v1'
type Saved={id:string;secret:string}
function readSaved():Saved|null{
 try{const v=JSON.parse(window.sessionStorage.getItem(sessionKey)||'null');return v&&typeof v.id==='string'&&typeof v.secret==='string'?v:null}catch{return null}
}

export function TableViewGuest(){
 const [open,setOpen]=useState(false)
 const [table,setTable]=useState('')
 const [saved,setSaved]=useState<Saved|null>(readSaved)
 const [result,setResult]=useState<GuestResponse|null>(null)
 const [busy,setBusy]=useState(false)
 const [error,setError]=useState('')
 const check=useCallback(async(request:Saved)=>{
  const {data,error:issue}=await supabase.rpc('table_view_guest_status',{p_request_id:request.id,p_secret:request.secret})
  if(issue){setError('Não foi possível consultar o status. Tente novamente.');return}
  const view=(data||{}) as GuestResponse
  if(view.status==='invalid'||view.status==='expired'||view.status==='denied'){
   window.sessionStorage.removeItem(sessionKey);setSaved(null)
  }
  setResult(view)
 },[])
 useEffect(()=>{
  if(!open||!saved)return
  void check(saved)
  const interval=window.setInterval(()=>void check(saved),5000)
  return()=>window.clearInterval(interval)
 },[open,saved,check])
 async function request(event:FormEvent){
  event.preventDefault();setError('')
  const number=Number(table)
  if(!Number.isSafeInteger(number)||number<=0){setError('Informe o número correto da mesa.');return}
  const secret=crypto.randomUUID()
  setBusy(true)
  const {data,error:issue}=await supabase.rpc('request_table_view',{p_table_number:number,p_secret:secret})
  setBusy(false)
  const response=(data||{}) as GuestResponse
  if(issue||response.error||!response.id){setError(response.error||issue?.message||'Não foi possível pedir autorização.');return}
  const next={id:response.id,secret}
  window.sessionStorage.setItem(sessionKey,JSON.stringify(next));setSaved(next);setResult({status:'pending'})
 }
 function reset(){window.sessionStorage.removeItem(sessionKey);setSaved(null);setResult(null);setError('')}
 return <>
   <button className="public-table-view-trigger" type="button" onClick={()=>setOpen(true)}><LockKeyhole size={21}/><span><strong>Ver minha comanda</strong><small>Consulta protegida · autorização do caixa</small></span><ClipboardList size={23}/></button>
   {open&&<div className="public-table-view-backdrop" role="presentation" onMouseDown={()=>setOpen(false)}>
     <section className="public-table-view-dialog" role="dialog" aria-modal="true" aria-label="Consultar comanda da mesa" onMouseDown={e=>e.stopPropagation()}>
       <header><div><small>GONÇALO MUSIC BAR</small><h2>Minha comanda</h2></div><button type="button" aria-label="Fechar" onClick={()=>setOpen(false)}><X size={21}/></button></header>
       {!saved?<form onSubmit={request} className="public-table-view-request">
         <div className="public-table-view-lock"><LockKeyhole size={28}/><strong>Seu consumo, só com permissão</strong><p>Informe sua mesa. O caixa confere se você está nela e autoriza visualizar o consumo conjunto.</p></div>
         <label>Número da mesa<input type="number" inputMode="numeric" min="1" max="99999" value={table} onChange={e=>setTable(e.target.value)} placeholder="Ex.: 12" required autoFocus/></label>
         {error&&<p className="public-table-view-error" role="alert">{error}</p>}
         <button className="public-table-view-primary" disabled={busy}>{busy?'Enviando…':'Solicitar acesso ao caixa'}</button>
       </form>:<>
         {error&&<p className="public-table-view-error" role="alert">{error}</p>}
         {(!result||result.status==='pending')&&<div className="public-table-view-await"><Clock3 size={38}/><h3>Aguardando autorização</h3><p>A solicitação chegou ao sistema. Peça ao caixa para conferir sua mesa e liberar o acesso.</p><button type="button" onClick={()=>void check(saved)}><RefreshCw size={16}/> Atualizar status</button></div>}
         {result?.status==='approved'&&<div className="public-table-view-account">
           <div className="public-table-view-approved"><ShieldCheck size={23}/><div><strong>Mesa {result.table_number} · Visualização autorizada</strong><small>Comanda conjunta desta mesa · somente consulta</small></div></div>
           <h3>Produtos consumidos</h3>
           {(result.items||[]).length?<div className="public-table-view-items">{result.items!.map((item,i)=><div key={i}><span>{item.quantity}× {item.product_name}</span><strong>{money.format(Number(item.total))}</strong></div>)}</div>:<p>Nenhum produto registrado no atendimento atual.</p>}
           <div className="public-table-view-totals"><div><span>Total registrado</span><b>{money.format(Number(result.total||0))}</b></div><div><span>Já pago</span><b>{money.format(Number(result.paid||0))}</b></div><div><strong>Saldo restante</strong><strong>{money.format(Number(result.remaining||0))}</strong></div></div>
           <p>Para conferir divergências ou pagar a conta, chame o garçom. Os valores são atualizados automaticamente.</p>
         </div>}
         {['denied','expired','invalid'].includes(result?.status||'')&&<div className="public-table-view-await"><LockKeyhole size={32}/><h3>{result?.status==='denied'?'Solicitação não autorizada':'Acesso encerrado'}</h3><p>Consulte o caixa e solicite novamente, se necessário.</p></div>}
         <button type="button" className="public-table-view-reset" onClick={reset}>Solicitar para outra mesa</button>
       </>}
     </section>
   </div>}
 </>
}
